// extracted by mini-css-extract-plugin
export default {"btn":"secondaryButton_btn__mnv2LUxe","default":"secondaryButton_default__DsE-dLN1","active":"secondaryButton_active__Y78IH4Ix"};